/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AuthService } from './services/AuthService';
import { HampService } from './services/HampService';
import { HdspService } from './services/HdspService';
import { HrppService } from './services/HrppService';
import { HspService } from './services/HspService';
import { HsspService } from './services/HsspService';
import { HstpService } from './services/HstpService';
import { HvpService } from './services/HvpService';
import { InfoService } from './services/InfoService';
import { SliderService } from './services/SliderService';
import { SseService } from './services/SseService';
import { StreamService } from './services/StreamService';
import { UtilsService } from './services/UtilsService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class HandyApi {

    public readonly auth: AuthService;
    public readonly hamp: HampService;
    public readonly hdsp: HdspService;
    public readonly hrpp: HrppService;
    public readonly hsp: HspService;
    public readonly hssp: HsspService;
    public readonly hstp: HstpService;
    public readonly hvp: HvpService;
    public readonly info: InfoService;
    public readonly slider: SliderService;
    public readonly sse: SseService;
    public readonly stream: StreamService;
    public readonly utils: UtilsService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://www.handyfeeling.com/api/handy-rest/v3',
            VERSION: config?.VERSION ?? '3.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.auth = new AuthService(this.request);
        this.hamp = new HampService(this.request);
        this.hdsp = new HdspService(this.request);
        this.hrpp = new HrppService(this.request);
        this.hsp = new HspService(this.request);
        this.hssp = new HsspService(this.request);
        this.hstp = new HstpService(this.request);
        this.hvp = new HvpService(this.request);
        this.info = new InfoService(this.request);
        this.slider = new SliderService(this.request);
        this.sse = new SseService(this.request);
        this.stream = new StreamService(this.request);
        this.utils = new UtilsService(this.request);
    }
}

